import { callUserActive } from './actionCreators/userActive';

const fetchInitialData = dispatch => {
  callUserActive(dispatch);
}

export default fetchInitialData;